<template>
	<t-icon-button
		:class="{active: isActive}"
		:icon="icon"
		:iconSize="iconSize"
		class="nav-item"
		appearance="nav"
		type="bp"
		@click="onNavigate"
	/>
</template>

<script>
import TIconButton from '../../buttons/TIconButton';
export default {
	name: 'TNavItem',
	inject: [ 'toggleSlide', 'setShowSlide', 'isSlideShowing' ],
	components: { TIconButton },
	props: {
		icon: String,
		to: [ String, Object ],
		iconSize: {
			type: String,
			default: 'xs'
		},
		showSlide: {
			type: Boolean,
			default: true,
		},
		active: Boolean,
	},
	computed: {
		isActive() {
			if (typeof this.to === 'object') {
				let pathArray = this.$route.fullPath.split('/');
				if (this.to.path) return this.to.path === pathArray[1];
				if (this.to.name) return this.to.name === this.$route.name || this.to.name === pathArray[1];
			} else {
				return this.$route.path.includes(this.to);
			}

			return false;
		}
	},
	methods: {
		onNavigate(event) {
			if (this.isActive) {
				this.$emit('click:active', event);
			} else {
				if (this.to) {
					this.$router.push(this.to);
				}
				this.$emit('click:inActive', event);
			}

			this.$emit('click', event);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
.active {
	background-color: get-color($neutral-scale, 'N10');
}
</style>
